<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card>
            <b-row class="mb-3">
              <b-col cols="6" class="mt-1">
                <h4>{{ 'orders_list_title' | translate('global') }}</h4>
              </b-col>
              <b-col cols="6">
                <div class="pull-right">
                  <b-button variant="primary" class="mt-1"  :disabled="disabledButtons.create"
                            :to="{ name: 'OrderCreate' }">
                    <i class="fa fa-plus mr-2"></i>{{ 'add_new' | translate('global') }}
                  </b-button>
                </div>
              </b-col>
            </b-row>
            <hr>

            <div v-if="spinners.contentIsLoading" class="text-center">
              <b-spinner type="grow" variant="primary"/>
            </div>

            <div v-else>
              <!--------FILTERS---------------------->
              <b-row>
                <b-col cols="6" xl="4">
                  <b-form-group>
                    <treeselect :default-expand-level="1"
                                :placeholder="'select_creator' | translate('global')"
                                instanceId="loadUsers"
                                :load-options="loadOptions" :async="true" :cacheOptions="false"
                                :searchPromptText="'creator_autocomplete' | translate('global')"
                                :noResultsText="'no_results_found' | translate('global')"
                                v-model="filters.user"/>
                  </b-form-group>
                </b-col>
                <b-col cols="6" xl="4">
                  <b-form-group>
                    <treeselect :options="structureOptions" :default-expand-level="1"
                                :placeholder="'select_structure' | translate('global')"
                                v-model="filters.structure"/>
                  </b-form-group>
                </b-col>
                <b-col cols="6" xl="4">
                  <b-form-group>
                    <treeselect :default-expand-level="1"
                                :placeholder="'supplier_select' | translate('global')"
                                instanceId="loadSuppliers"
                                :load-options="loadOptions" :async="true" :cacheOptions="false"
                                :searchPromptText="'supplier_autocomplete' | translate('global')"
                                :noResultsText="'no_results_found' | translate('global')"
                                v-model="filters.supplier"/>
                  </b-form-group>
                </b-col>
                <b-col cols="6" xl="4">
                  <b-form-group>
                    <treeselect :options="statusOptions" :default-expand-level="1"
                                :placeholder="'select_status' | translate('global')"
                                v-model="filters.status"/>
                  </b-form-group>
                </b-col>
                <b-col cols="12" xl="4">
                  <b-form-group>
                    <datepicker :placeholder="'select_date_range' | translate('global')"
                                v-model="filters.dateRange" range format="DD.MM.YYYY"
                                v-bind:value-type="getServerTimeFormatWithoutTime()"/>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="6" xl="4">
                  <b-form-group>
                    <b-row>
                      <b-col cols="5">
                        <b-form-input type="number" min="0"
                                      :placeholder="'price_from' | translate('global')"
                                      v-model="filters['total_sum[from]']"/>
                      </b-col>
                      <b-col cols="2" class="text-center">
                        <i class="fa fa-minus minus"/>
                      </b-col>
                      <b-col cols="5">
                        <b-form-input type="number" min="0"
                                      :placeholder="'price_to' | translate('global')"
                                      v-model="filters['total_sum[to]']"/>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
                <b-col cols="6" xl="3">
                  <b-form-group>
                    <treeselect :options="factsOptions" :default-expand-level="1"
                                :placeholder="'select_fact_status' | translate('global')"
                                v-model="filters['fact_status']"/>
                  </b-form-group>
                </b-col>
                <b-col cols="6" xl="3">
                  <b-form-group>
                    <treeselect :options="invoicesOptions" :default-expand-level="1"
                                :placeholder="'select_invoice_status' | translate('global')"
                                v-model="filters['invoice_status']"/>
                  </b-form-group>
                </b-col>
                <b-col cols="6" xl="3">
                  <b-form-group>
                    <treeselect :options="documentsAttachedOptions" :default-expand-level="1"
                                :placeholder="'select_documents_attached_status' | translate('global')"
                                v-model="filters['all_documents_attached']"/>
                  </b-form-group>
                </b-col>
                <b-col cols="6" xl="3">
                  <b-form-group>
                    <treeselect :options="advanceInvoiceOptions" :default-expand-level="1"
                                :placeholder="'select_advance_invoice_status' | translate('global')"
                                v-model="filters['adv_invoice_status']"/>
                  </b-form-group>
                </b-col>
                <b-col cols="12" class="mb-2">
                  <b-button variant="primary" block @click="getData()"
                            :disabled="disabledButtons.filter">
                    {{ 'filter' | translate('global') }}
                  </b-button>
                </b-col>
              </b-row>
              <!--------END OF FILTERS--------------->

              <b-row>
                <b-col cols="12">
                  <EmptyTable v-if="!tableItems.length"/>
                  <b-table v-else class="table-sm text-center"
                           responsive bordered :fields="tableFields" :items="tableItems">
                    <template v-slot:options="row">
                      <div class="flex-container options-center">
                        <Copy :orderId="row.item.id" class="mr-3"/>
                        <router-link :to="{ name: 'OrderUpdate', params:{ id: row.item.id }}">
                          <a><i class="fa fa-edit fa-lg"/></a>
                        </router-link>
                      </div>
                    </template>
                  </b-table>
                </b-col>
              </b-row>
              <b-row>
                <!--Paginator-->
                <b-col cols="12" v-if="tableItems.length">
                  <Pagination :data="listPaginator" :limit="5" @pagination-change-page="onPageChange"/>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import statuses from '@/store/statuses';
import { mapGetters, mapActions } from 'vuex';
import Pagination from 'laravel-vue-pagination';
import VuexTypes from '@/store/types/index';
import EmptyTable from '@/views/sharedComponents/EmptyTableData';
import forEach from 'lodash.foreach';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import TreeselectMixin from '@/mixins/TreeselectMixin';
import ServerTimeFormatMixin from '@/mixins/ServerTimeFormatMixin';
import Services from '@/services/index';
import Datepicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/lv';
import Copy from './CopyOrder.vue';

const SuppliersService = Services.suppliers;
const OrdersService = Services.orders;
const OrdersTypes = VuexTypes.orders;
export default {
  mounted() {
    this.getData();
  },
  props: ['page'],
  mixins: [TreeselectMixin, ServerTimeFormatMixin],
  data() {
    return {
      spinners: {
        contentIsLoading: true,
      },
      disabledButtons: {
        filter: false,
        create: true
      },
      filters: {
        user: null,
        structure: null,
        supplier: null,
        status: null,
        dateRange: null,
        'total_sum[from]': null,
        'total_sum[to]': null,
        fact_status: null,
        invoice_status: null,
        all_documents_attached: null,
        adv_invoice_status: null
      },
      structureOptions: [],
      statusOptions: [],
      factsOptions: [],
      invoicesOptions: [],
      documentsAttachedOptions: [],
      advanceInvoiceOptions: [],
      tableFields: [
        { key: 'creator', label: this.$t('creator', 'global') },
        { key: 'structure', label: this.$t('structure', 'global') },
        { key: 'created_at', label: this.$t('created_at', 'global') },
        { key: 'supplier', label: this.$t('supplier', 'global') },
        { key: 'total', label: this.$t('order_total', 'global') },
        { key: 'status', label: this.$t('status', 'global') },
        { key: 'options', label: this.$t('options', 'global') }
      ],
      tableItems: [],
    };
  },
  components: {
    Pagination, Treeselect, Datepicker, EmptyTable, Copy
  },
  computed: {
    ...mapGetters('Orders', [
      'ordersList',
      'ordersListFilters',
      'orderCopy'
    ]),
    params() {
      const data = {};
      forEach(this.filters, (value, param) => {
        if (value) {
          if (param === 'dateRange') {
            data['created_at[from]'] = value[0];
            data['created_at[to]'] = value[1];
          } else {
            data[param] = value;
          }
        }
      });
      data['page'] = this.page;
      return data;
    },
    listPaginator() {
      return this.ordersList.data.meta;
    },
    list() {
      return this.ordersList;
    }
  },
  watch: {
    page: 'getData',
    listPaginator: {
      handler: function () {
        if (this.listPaginator && this.listPaginator.last_page < this.page) {
          this.onPageChange(this.listPaginator.last_page);
        }
      },
      deep: true
    },
    list: {
      handler: function () {
        this.disabledButtons.filter = false;
        if (this.list['status'] === statuses.LOADED) {
          this.fillTableData();
          this.spinners.contentIsLoading = false;

          const data = this.list.data;
          const actions = data ? data['actions'] : data['actions'];
          this.disabledButtons.create = !actions['create'];
        }
      },
      deep: true
    },
    ordersListFilters: {
      handler: function () {
        if (this.ordersListFilters['status'] === statuses.LOADED) {
          this.fillFilterData();
        }
      },
      deep: true
    },
    orderCopy: {
      handler: function () {
        if (this.orderCopy.status === statuses.LOADED) {
          this.alertSuccess();
          this.$router.push({ name: 'OrderUpdate', params: { id: this.orderCopy.data.id } });
        } else if (this.orderCopy.status === statuses.ERROR) {
          this.alertError();
        }
      },
      deep: true
    },
  },
  methods: {
    ...mapActions('Orders', [
      OrdersTypes.ORDERS_LIST,
      OrdersTypes.ORDERS_LIST_FILTERS,
    ]),
    getData() {
      this.disabledButtons.filter = true;
      this.ORDERS_LIST(this.params);
      this.ORDERS_LIST_FILTERS();
    },
    fillTableData() {
      const result = [];
      forEach(this.list.data.data, (order) => {
        result.push({
          id: order['id'],
          creator: order['user'] ? order['user']['full_name'] : null,
          structure: order['structure'] ? order['structure']['name'] : null,
          supplier: order['supplier'] ? order['supplier']['name'] : null,
          total: order['total_sum'],
          status: this.$t(order['status'], 'statuses'),
          created_at: order['created_at'],
          updated_at: order['updated_at'],
        });
      });

      this.tableItems = result;
    },
    fillFilterData() {
      this.structureOptions = this.fillTreeselectDropdown(
        this.ordersListFilters.data['structures'], 'id', 'name'
      );

      let statuses = [];

      forEach(this.ordersListFilters.data['statuses'], (status) => {
        statuses.push({
          id: status,
          label: this.$t(status, 'statuses'),
        });
      });
      this.statusOptions = statuses;
      statuses = [];

      forEach(this.ordersListFilters.data['invoice_statuses'], (status) => {
        statuses.push({
          id: status,
          label: this.$t(status, 'statuses')
        });
      });
      this.invoicesOptions = statuses;
      statuses = [];

      forEach(this.ordersListFilters.data['fact_statuses'], (status) => {
        statuses.push({
          id: status,
          label: this.$t(status, 'statuses')
        });
      });
      this.factsOptions = statuses;
      statuses = [];

      forEach(this.ordersListFilters.data['adv_invoice_statuses'], (status) => {
        statuses.push({
          id: status,
          label: this.$t(status, 'statuses')
        });
      });
      this.advanceInvoiceOptions = statuses;
      this.documentsAttachedOptions = [
        {
          id: '1',
          label: this.$t('is_all_documents_attached', 'global')
        },
        {
          id: '0',
          label: this.$t('not_all_documents_attached' ,'global')
        }
      ];
    },
    async loadOptions({ action, searchQuery, callback, instanceId }) {
      let options = [];
      const query = searchQuery.trim();
      if (action === 'ASYNC_SEARCH') {
        const valid = this.checkSearchQuery(query);
        if (valid) {
          options = await this[instanceId](query);
        }
      }
      callback(null, options);
    },
    async loadSuppliers(name) {
      const param = name || '';
      const data = await SuppliersService.search(param);
      const options = [];
      forEach(data.data.data, (item) => {
        options.push({
          id: item['id'],
          label: item['name']
        });
      });
      return options;
    },
    async loadUsers(name) {
      const param = name || '';
      const data = await OrdersService.searchUser(param);
      const options = [];
      forEach(data.data.data, (item) => {
        options.push({
          id: item['id'],
          label: item['full_name']
        });
      });
      return options;
    },
    onPageChange(page) {
      if (!page) {
        page = this.page;
      }
      if (page !== this.page) {
        this.$router.push({ name: 'Orders', params: { page } });
      }
    },
  }
};
</script>

<style scoped>
  .minus {
    margin-top: 10px;
    color: #c5bdc2
  }
  .options-center {
    justify-content: center
  }
</style>
